import channelsService from "@/services/channelsService";

const state = () => ({
  all: [],
  single: null
});

const actions = {
  async create({ dispatch }, formData) {
    try {
      const res = await channelsService.create(formData);
      dispatch("findAll");
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Channel konnte nicht erstellt werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findAll({ commit, dispatch }) {
    try {
      const res = await channelsService.findAll();
      commit("setAll", res.data);
      return Promise.resolve(JSON.parse(JSON.stringify(res.data)));
    } catch (error) {
      dispatch(
        "common/showError",
        "Channel konnten nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findOne({ commit, dispatch }, { id }) {
    commit("setSingle", null);
    try {
      const res = await channelsService.findOne({ id });
      // commit("setSingle", JSON.parse(JSON.stringify(res.data)));
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Channel konnte nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async delete({ dispatch }, { id }) {
    try {
      await channelsService.delete({ id });
      dispatch("findAll");
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Channel konnte nicht gelöscht werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async update({ dispatch }, formData) {
    try {
      const res = await channelsService.update(formData);
      dispatch("findAll");
      dispatch(
        "common/showSuccess",
        "Channel wurde erfolgreich aktualisiert.",
        { root: true }
      );
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Channel konnte nicht aktualisiert werden.",
        { root: true }
      );
      return Promise.reject();
    }
  }
};

const getters = {
};

const mutations = {
  setAll(state, object) {
    state.all = object;
  },
  setSingle(state, object) {
    state.single = object;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
